import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type { ReactElement, ReactNode } from "react";

// The name of a control that shows only its icon (design-system.md §3): the places of the narrow sidebar. It does
// not replace the accessible name, which the control keeps; on touch screens, without hover, it never opens.

interface TooltipProps {
  /** The control, with its own accessible name. */
  children: ReactElement;
  content: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
}

export function Tooltip({ children, content, side = "right" }: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} sideOffset={8} className="z-30 pointer-coarse:hidden">
          <BaseTooltip.Popup className="flex items-center gap-2 rounded-md border border-border bg-popover px-2 py-1 text-xs text-popover-foreground shadow-popover transition-opacity duration-150 ease-out data-[ending-style]:opacity-0 data-[starting-style]:opacity-0">
            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}

/** One delay for the tooltips under it: moving from one icon to the next opens the next at once. */
export const TooltipGroup = BaseTooltip.Provider;
